import { useMemo } from 'react';
import { useApp } from '../context/AppContext';
import { archetypes } from '../data/archetypes';
import DrawingCanvas from '../components/DrawingCanvas';
import styles from './DrawingPage.module.css';

export default function DrawingPage() {
  const { state, dispatch } = useApp();

  const { primary } = useMemo(() => {
    const sorted = Object.entries(state.scores).sort((a, b) => b[1] - a[1]);
    const primaryKey = sorted[0] ? sorted[0][0] : 'jester';
    const primary = archetypes[primaryKey];
    return { primary };
  }, [state.scores]);

  const handleBack = () => {
    dispatch({ type: 'SET_PAGE', payload: 'result' });
  };

  return (
    <div className={styles.container}>
      <DrawingCanvas
        archetype={`${primary.name} · ${primary.planet}`}
        onSave={handleBack}
        onClose={handleBack}
        isFullPage={true}
      />
    </div>
  );
}
